const en = {
  app: {
    name: "Top of Descent Calculator",
    shortName: "T/D Calculator",
    subtitle: "Approximate descent planning tool",
    badge: "Frontend-only calculator",
    disclaimer:
      "This calculator is intended only for educational and approximate planning use. It is not certified for operational aviation use.",
  },
  language: {
    label: "Language",
    uzbek: "O'zbek",
    russian: "Русский",
    english: "English",
  },
  nav: {
    calculator: "Calculator",
    results: "Results",
    info: "Information",
  },
  form: {
    title: "Descent parameters",
    altitudeSection: "Altitude",
    speedSection: "Speed and wind",
    profileSection: "Profile",
    startAltitude: "Start altitude",
    endAltitude: "End altitude",
    groundSpeed: "Ground speed",
    finalSpeed: "Final speed",
    wind: "Wind",
    glideSlope: "Glide slope",
    verticalSpeed: "Vertical speed",
    startAltitudePlaceholder: "Example: 30 000",
    endAltitudePlaceholder: "Example: 10 000",
    groundSpeedPlaceholder: "Example: 320",
    finalSpeedPlaceholder: "Example: 250",
    windPlaceholder: "Example: 0",
    glideSlopePlaceholder: "Example: 3",
    verticalSpeedPlaceholder: "Example: 1 500",
    calculate: "Calculate",
    reset: "Reset",
    fillExample: "Fill example",
    helperProfile:
      "Glide slope and vertical speed are linked — changing either value updates the other.",
  },
  units: {
    feet: "ft",
    knots: "kts",
    degrees: "°",
    fpm: "fpm",
    nauticalMiles: "NM",
    minutes: "min",
  },
  results: {
    title: "Computed results",
    empty: "Enter values to see results.",
    verticalSpeed: "Vertical speed",
    topOfDescent: "Top of descent",
    estimatedTime: "Estimated time",
    approximate: "Approximate calculation",
  },
  info: {
    title: "Calculation information",
    howItWorks: "How it works",
    description:
      "Distance to top of descent is calculated from altitude delta, glide slope angle, and average ground speed. Speed change and wind corrections are applied as additive factors.",
    formulaLabel: "Base formula",
    formula: "distance = altitude delta × tan(glide slope) × speed factor",
    safetyTitle: "Educational and planning use only",
    safetyText:
      "In real flight operations, aircraft type, flight envelope, atmospheric conditions, ATC instructions, and official navigation data take priority.",
  },
  validation: {
    required: "This field is required.",
    invalidNumber: "Enter a valid number.",
    invalidAltitude: "End altitude must be lower than start altitude.",
    startAltitudeTooLow:
      "Start altitude must be higher than end altitude.",
    invalidSpeed: "Speed must be a positive value.",
    invalidGlideSlope: "Glide slope must be greater than 0.",
    invalidVerticalSpeed: "Vertical speed must be a positive value.",
  },
  footer: {
    text: "Top of Descent Calculator · Approximate descent planning tool",
    version: "Version",
  },
  status: {
    ready: "Ready",
    calculating: "Calculating",
    invalid: "Check the entered data",
  },
};

export default en;
